import { Flex, Heading, Link, Tooltip } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link as RouterLink } from 'react-router-dom';

function Header() {
  return (
    <Flex justify="space-between" align="center">
      <Heading as="h4" size="md" mb={8}>
        <FontAwesomeIcon icon={['fal', 'file-contract']} /> Contracts
      </Heading>
      <Tooltip label="New Contract" hasArrow placement="left">
        <Link ml={2} as={RouterLink} to="contracts/new">
          <FontAwesomeIcon icon={['fal', 'plus']} size="lg" />
        </Link>
      </Tooltip>
    </Flex>
  );
}

export default Header;
